import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { cadastrarLocalidadesAtendidas } from '../servicos/cadastroServico';
import { aplicarMascaraValor } from '../uteis/mascaras/mascaraValor';
import { FaMapMarkerAlt, FaDollarSign, FaMoon, FaSun, FaCity, FaStickyNote } from 'react-icons/fa';

const valoresIniciais = {
  localidade_atendida_id: null,
  ponto_mototaxi_id: null,
  nome: '',
  cidade: '',
  uf: '',
  valor_6_as_23: '',
  valor_23_as_6: '',
  observacao: '',
};

function CadastrarLocalidadesAtendidas() {

  const [formData, setFormData] = useState(valoresIniciais);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('📍 Página CadastrarLocalidadesAtendidas carregada.');
    const cookies = Cookies.get();
    const dadosCookiesString = cookies.dadosCookies;

    if (dadosCookiesString) {
      try {
        const dadosCookies = JSON.parse(dadosCookiesString);
        const idPontoMototaxi = dadosCookies?.dadosPontoMototaxi?.id;
        console.log('🏍 ID ponto mototaxi:', idPontoMototaxi);

        setFormData((prev) => ({
          ...prev,
          ponto_mototaxi_id: idPontoMototaxi
        }));
      } catch (err) {
        console.error('❌ Erro ao ler dadosCookies:', err);
      }
    }
  }, []);

  const parseValorParaCentavos = (valorMascarado) => {
    if (!valorMascarado) return 0;
    const apenasNumeros = String(valorMascarado).replace(/\D/g, '');
    return apenasNumeros === '' ? 0 : parseInt(apenasNumeros, 10);
  };

  const handleChange = (campo, valor) => {
    let novoValor = valor;
    if (campo === 'valor_6_as_23' || campo === 'valor_23_as_6') {
      novoValor = aplicarMascaraValor(valor);
    }
    setFormData((prev) => ({
      ...prev,
      [campo]: novoValor
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('🚀 Enviando dados (mascarado):', formData);

    const dadosParaEnviar = {
      ...formData,
      valor_6_as_23_centavos: parseValorParaCentavos(formData.valor_6_as_23),
      valor_23_as_6_centavos: parseValorParaCentavos(formData.valor_23_as_6)
    };

    try {
      await cadastrarLocalidadesAtendidas([dadosParaEnviar]);
      console.log('✅ Localidade cadastrada com sucesso!');
      navigate('/listar-localidades-atendidas');
    } catch (err) {
      console.error('❌ Erro ao cadastrar localidade:', err);
    }
  };

  return (
    <div className="container py-4">
      <div className="text-center mb-5">
        <FaMapMarkerAlt size={40} className="text-primary mb-2" />
        <h2 className="fw-bold text-primary">Cadastrar Localidade Atendida</h2>
        <p className="text-muted">Preencha as informações da localidade e salve.</p>
      </div>

      <form onSubmit={handleSubmit} className="card shadow border-0 p-4 bg-light">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label fw-semibold">
              Nome da Localidade
            </label>
            <input
              type="text"
              className="form-control rounded-pill"
              value={formData.nome}
              onChange={(e) => handleChange('nome', e.target.value)}
              placeholder="Ex: Bairro Central"
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">
              <FaCity className="me-1" /> Cidade
            </label>
            <input
              type="text"
              className="form-control rounded-pill"
              value={formData.cidade}
              onChange={(e) => handleChange('cidade', e.target.value)}
              placeholder="Cidade"
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label fw-semibold">UF</label>
            <input
              type="text"
              className="form-control rounded-pill"
              value={formData.uf}
              onChange={(e) => handleChange('uf', e.target.value.toUpperCase())}
              placeholder="UF"
              maxLength={2}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-semibold">
              <FaSun className="text-warning me-1" /> Valor (06h às 23h)
            </label>
            <input
              type="text"
              inputMode="numeric"
              className="form-control rounded-pill"
              value={formData.valor_6_as_23}
              onChange={(e) => handleChange('valor_6_as_23', e.target.value)}
              placeholder="0,00"
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-semibold">
              <FaMoon className="text-secondary me-1" /> Valor (23h às 06h)
            </label>
            <input
              type="text"
              inputMode="numeric"
              className="form-control rounded-pill"
              value={formData.valor_23_as_6}
              onChange={(e) => handleChange('valor_23_as_6', e.target.value)}
              placeholder="0,00"
            />
          </div>

          <div className="col-12">
            <label className="form-label fw-semibold">
              <FaStickyNote className="me-1" /> Observação
            </label>
            <input
              type="text"
              className="form-control rounded-pill"
              value={formData.observacao}
              onChange={(e) => handleChange('observacao', e.target.value)}
              placeholder="Observações adicionais"
            />
          </div>
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-lg btn-success rounded-pill px-5 shadow">
            <FaDollarSign className="me-2" /> Salvar Localidade
          </button>
        </div>
      </form>
    </div>
  );
}

export default CadastrarLocalidadesAtendidas;
